import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: "/",
    component: () => import('@/views/before/index.vue'),
    children: [{
        path: '/',
        name: 'beforeHome',
        component: () => import('@/views/before/Home.vue'),
      },
      {
        path: '/policy',
        name: 'beforePolicy',
        component: () => import('@/views/before/policy.vue'),
      },
      {
        path: '/inventory',
        name: 'beforeInventory',
        component: () => import('@/views/before/inventory.vue')
      },
      {
        path: '/policyInfo',
        name: 'beforePolicyInfo',
        component: () => import('@/views/before/infos/policyInfo.vue')
      },
      {
        path: '/homeInfo',
        name: 'beforeHomeInfo',
        component: () => import('@/views/before/infos/homeInfo.vue')
      }
    ]
  },
  {
    path: "/after",
    component: () => import("@/views/after/index.vue"),
    children: [{
      path: "/",
      name: "AfterHome",
      component: () => import("@/views/after/home.vue")
    }, {
      path: "/bility",
      name: "AfterBility",
      component: () => import("@/views/after/responsibility.vue")
    }, {
      path: "/bilityInfos",
      name: "AfterBilityInfos",
      component: () => import("@/views/after/infos/bilityInfos.vue")
    }, {
      path: "/policyList",
      name: "AfterPolicyList",
      component: () => import("@/views/after/policyList.vue")
    }, {
      path: "/policyInfos",
      name: "AfterPolicyInfos",
      component: () => import("@/views/after/infos/policyInfos.vue")
    }, {
      path: "/departSearch",
      name: "AfterDepartSearch",
      component: () => import("@/views/after/departSearch.vue")
    }]
  },
  {
    path: "/bigData",
    component: () => import("@/views/bigData/bigData.vue")
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router